module.exports = __webpack_public_path__ + "img/logo-admin_client_branch.5ef42b06.svg";